module.exports = __webpack_public_path__ + "img/pop_icon_benefit@2x.faed103d.png";